// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__jDx0q","employee-header-item":"Header_employee-header-item__-RxyY"};